<xux-widget-boilerplate [field]="field">
  <!-- see dropdown documentation at https://valor-software.com/ngx-bootstrap/#/dropdowns -->
  <div class="btn-group dropdown xux-dropdown" data-e2e-id="entity-select-dropdown">
    <div
      class="btn dropdown-toggle"
      #dropdownTarget
      (click)="displayMenu($event)"
      [attr.aria-expanded]="isMenuAlreadyOpen"
    >
      <input
        #defaultFocusElement
        type="search"
        class="filter-field"
        [formControl]="searchControl"
        [readonly]="!canSearch"
        [placeholder]="(placeholder$ | async) || ''"
        data-e2e-id="entity-select-search"
        [attr.customScanning]="true"
      />
      <span
        [class]="
          (busy$ | async) ? 'glyphicon glyphicon-refresh glyphicon-refresh-animate' : 'glyphicon glyphicon-menu-down'
        "
      ></span>
    </div>
  </div>
</xux-widget-boilerplate>
